/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import _ from 'lodash';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { MLLocalDateUtil } from 'ml-portals-util-js';
import { useTranslator } from '@jutro/locale';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import metadata from './PUPVehicleTableComponent.metadata.json5';
import messages from './PUPVehicleTableComponent.messages';
import styles from './PUPVehicleTableComponent.module.scss';
import { Link } from '@jutro/router';

function PUPVehicleTableComponent(props) {
    const {
        list,
        goBackToStep,
        isWatercraft
    } = props;

    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const watercraftTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('PUPWatercraftType_PUE');
    const vehicleTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('PUPVehicleType_PUE');

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };

    const getExcludedVal = (item) => {
        const path = isWatercraft ? 'isExcluded' : 'excluded';
        const boolVal = _.get(item, path);
        return boolVal ? translator(messages.yes) : translator(messages.no);
    };

    const getCellVal = (item, index, prop) => {
        return _.get(item, prop.path, undefined);
    };

    const getTypeVal = (item) => {
        if (isWatercraft) {
            const type = _.get(item, 'watercraftType', undefined);
            if (type) {
                const { name } = watercraftTypeList.getCode(type);
                return getTypeKeyDescription(name);
            }
            return '';
        }

        if (!item.error) {
            const type = _.get(item, 'type', undefined);
            if (type) {
                const { name } = vehicleTypelist.getCode(type);
                return (
                    <span className="font-weight-bold">
                        {getTypeKeyDescription(name)}
                    </span>
                );
            }
        } else {
            return (
                <i className="icon-ml-alert-icon icon-red" />
            )
        }
    };

    const getDateCell = (items, index, prop) => {
        const dateVal = getCellVal(items, index, prop);
        return dateVal ? MLLocalDateUtil.localDate2Date(dateVal, true) : undefined;
    };

    const getActionsCell = (item) => {
        if (_.isEmpty(item)) {
            return undefined;
        }
        return (
            <div className={styles.actionsCell}>
                <Link onClick={() => goBackToStep()}>{translator(messages.edit)}</Link>
                <Link onClick={() => goBackToStep()}>{translator(messages.remove)}</Link>
            </div>
        );
    };

    const renderTitle = () => {
        return (
            <h1 className="section-header vertical-spacing-20">
                {isWatercraft ? translator(messages.watercraft) : translator(messages.vehicles)}
            </h1>
        );
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellVal,
            getDateCell,
            getTypeVal,
            getActionsCell,
            getExcludedVal,
            onAddVehicle: goBackToStep
        },
        resolveClassNameMap: styles
    };

    const overrides = {
        vehicleTable: {
            data: list,
            renderTitle: renderTitle
        },
        addButton: {
            content: isWatercraft ? translator(messages.addWatercraft) : translator(messages.addVehicle)
        },
        vinCell: {
            visible: !isWatercraft
        },
        noInfoP: {
            visible: _.isEmpty(list)
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

PUPVehicleTableComponent.propTypes = {
    list: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    isWatercraft: PropTypes.bool,
    goBackToStep: PropTypes.func
};

PUPVehicleTableComponent.defaultProps = {
    isWatercraft: false,
    goBackToStep: _.noop
};

export default PUPVehicleTableComponent;
